import { render, staticRenderFns } from "./NationalPatentCountryForm.vue?vue&type=template&id=2bd80362&"
import script from "./NationalPatentCountryForm.vue?vue&type=script&lang=js&"
export * from "./NationalPatentCountryForm.vue?vue&type=script&lang=js&"
import style0 from "./NationalPatentCountryForm.vue?vue&type=style&index=0&id=2bd80362&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports